/* Site multi-services : menu mobile, menus déroulants, barre contact, présélection du formulaire. */
(function () {
  'use strict';
  if (window.M_SITE) return;
  window.M_SITE = true;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function initMenu() {
    var burger = $('[data-m-burger]');
    var nav = $('[data-m-nav]');
    if (!burger || !nav) return;
    function fermer() {
      nav.classList.remove('est-ouvert');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
    burger.addEventListener('click', function () {
      var ouvert = nav.classList.toggle('est-ouvert');
      burger.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      document.documentElement.style.overflow = ouvert ? 'hidden' : '';
    });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', fermer); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1000) fermer(); });

    var deroulants = $$('[data-m-deroulant]');
    deroulants.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) deroulants.forEach(function (autre) { if (autre !== d) autre.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (window.innerWidth < 1000) return;
      deroulants.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      deroulants.forEach(function (d) {
        if (d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); }
      });
      if (nav.classList.contains('est-ouvert')) { fermer(); burger.focus(); }
    });
  }

  function initBarre() {
    var barre = $('[data-m-barre]');
    if (!barre) return;
    var seuil = 520;
    var fin = $('#commencer') || $('[data-op-fin]');
    var finVisible = false;
    if (fin && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finVisible = e.isIntersecting; maj(); });
      }, { threshold: 0.2 }).observe(fin);
    }
    function maj() { barre.classList.toggle('est-visible', window.scrollY > seuil && !finVisible); }
    window.addEventListener('scroll', maj, { passive: true });
    maj();
  }

  function initFormulaire() {
    var select = $('[data-m-service]');
    if (!select) return;
    var service = new URLSearchParams(window.location.search).get('service');
    if (!service) return;
    $$('option', select).forEach(function (o) { if (o.value === service) select.value = service; });
  }

  function demarrer() { initMenu(); initBarre(); initFormulaire(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
